import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Space, Typography } from 'antd';
import { selectLoading, selectSkills, useContactStore } from 'stores/nic/stores/contactStore';
import { BaseDirectoryList } from './BaseDirectoryList';
var Text = Typography.Text;
export var SkillList = function () {
    var skills = useContactStore(selectSkills);
    var loading = useContactStore(selectLoading);
    var teamItems = useMemo(function () {
        return skills.map(function (skill) {
            var _a;
            return ({
                id: ((_a = skill.skillId) === null || _a === void 0 ? void 0 : _a.toString()) || '',
                name: skill.skillName || 'Unknown Skill',
                status: skill.isActive ? 'Active' : 'Inactive',
                description: "Members: ".concat((skills === null || skills === void 0 ? void 0 : skills.length) || 0),
                isAvailable: skill.isActive,
                additionalInfo: {
                    agentCount: skills === null || skills === void 0 ? void 0 : skills.length
                }
            });
        });
    }, [skills]);
    var renderSkillDescription = function (item) {
        var _a;
        return (_jsxs(Space, { orientation: "vertical", size: "small", children: [_jsxs(Text, { type: "secondary", children: ["Status: ", item.status] }), _jsx(Text, { type: "secondary", style: { fontSize: '12px' }, children: item.description }), ((_a = item.additionalInfo) === null || _a === void 0 ? void 0 : _a.teamLead) && (_jsxs(Text, { type: "secondary", style: { fontSize: '12px' }, children: ["Lead: ", item.additionalInfo.teamLead] })), _jsxs(Text, { type: "secondary", style: { fontSize: '12px' }, children: ["ID: ", item.id] })] }));
    };
    return (_jsx(BaseDirectoryList, { items: teamItems, loading: loading, renderDescription: renderSkillDescription, emptyText: "Skills not found" }));
};
